<template>
    <div class="user_content_blcok">
      <div class="user_content_blcok_title" style="position: relative;">
          我的订单
          <!-- <div class="order_search">
              <el-date-picker
              v-model="orderTime"
              type="date"
              @click="get_user_order()" 
              placeholder="选择日期"
              style="width:180px; margin-right:20px;"
              >
              
              </el-date-picker>
              <el-input v-model="keyword" placeholder="订单号或商品名称" @click="get_user_order()" size="mini" clearable style="width:180px; margin-right:20px;"></el-input>
              <el-button type="primary" @click="get_user_order()" size="mini">搜索</el-button>
          </div> -->
          <div class="order_type">
              <ul>
                  <li @click="order_type=''; current_page='1'; get_user_order()" :class="order_type=='' ?'red':''">全部 ({{count_list.quanbu}})</li>
                  <li @click="order_type='1';current_page='1'; get_user_order()" :class="order_type=='1'?'red':''">待支付 ({{count_list.daizhifu}})</li>
                  <li @click="order_type='5';current_page='1'; cancelOrderDisplay()"  :class="order_type=='5'?'red':''">已取消 ({{canceltotal}})</li>
                  <li @click="order_type='2';current_page='1'; get_user_order()" :class="order_type=='2'?'red':''">待发货 ({{count_list.daifahuo}})</li>
                  <li @click="order_type='3';current_page='1'; get_user_order()" :class="order_type=='3'?'red':''">待收货 ({{count_list.daishouhuo}})</li>
                  <li @click="order_type='4';current_page='1'; get_user_order()" :class="order_type=='4'?'red':''">售后处理 ({{count_list.shouhou}})</li>
              </ul>
          </div>
          <div class="clear"></div>
      </div>

      <div class="user_content_blcok_line"></div>

      <div class="order_search" style="text-align:right">
          <el-date-picker
            v-model="orderTime"
            type="datetimerange"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00','23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @click="get_user_order()" 
            align="center"
            size="mini"
            style="width:300px; margin-right:10px;"
          >
          </el-date-picker>
          <el-input v-model="keyword" placeholder="订单号或商品名称" @click="get_user_order()" size="mini" clearable style="width:200px; margin-right:10px;"></el-input>
          <el-button type="primary" @click="get_user_order()" size="mini">搜索</el-button>
          <el-button @click="handleResetSearch()" size="mini">重置</el-button>
      </div>

      <div class="clear"></div>

      <div class="user_content_blcok_line"></div>

      <div class="el-table el-table--border" v-if="order_list.length>0">
        <!-- v-loading="listLoading" -->
        <table cellspacing="0" cellpadding="0" border="0" style="width: 100%;" v-loading="listLoading"> 
            <thead class="has-gutter">
              <tr class="" span="6">
              <th class="is-leaf" style="text-align:center"><div class="cell">订单ID</div></th>
              <th class="is-leaf" style="text-align:center"><div class="cell">下单时间</div></th>
              <th class="is-leaf" style="text-align:center"><div class="cell">付款金额</div></th>
              <th class="is-leaf" style="text-align:center"><div class="cell">支付状态</div></th>
              <!-- <th class="is-leaf" style="text-align:center"><div class="cell">支付时间</div></th> -->
              <th class="is-leaf" style="text-align:center"><div class="cell">订单状态</div></th>
              <th class="is-leaf" style="text-align:center"><div class="cell">物流状态</div></th>
              <th class="is-leaf" style="text-align:center"><div class="cell">操作</div></th>
              <th class="is-leaf" style="text-align:center"><div class="cell">下载</div></th>
              </tr>
            </thead>
            <tbody >
              <tr class="el-table__row" v-for="v in order_list" :key="v.id">
                <td width="80" style="text-align:center"><div class="cell">{{v.id}}</div></td>
                <td width="150" style="text-align:center"><div class="cell">{{v.orderTime | formatCreateTime}}</div></td>
                <td width="100" style="text-align:center">
                  <div class="cell">
                    <p><el-tag size="small">订单：{{v.total}}</el-tag></p>
                    <p v-if="v.money"><el-tag size="small" type="success">实付：{{v.money}}</el-tag></p>
                    <p v-if="v.actualPayment"><el-tag size="small" type="info">支付：{{v.actualPayment}}</el-tag></p>
                  </div>
                </td>
                <td width="100" style="text-align:center">
                  <div class="cell">
                    <el-tag v-if="v.payState == 0 && v.status == 1" type="warning">未支付</el-tag>
                    <el-tag v-else-if="v.payState == 0 && v.status == 2" type="warning">待退款</el-tag>
                    <el-tag v-else-if="v.payState == 1" type="success">已支付</el-tag>
                    <el-tag v-else-if="v.payState == 2" type="warning">待审核</el-tag>
                    <el-tag v-else-if="v.payState == 3" type="success">已审核</el-tag>
                    <el-tag v-else-if="v.payState == 4" type="info">已退款</el-tag>
                    <el-tag v-else-if="v.payState == 5" type="warning">已取消</el-tag>
                    <el-tag v-else>暂无</el-tag>
                  </div>
                </td>
                <!-- <td width="100" style="text-align:center"><div class="cell">{{v.paytime | formatCreateTime}}</div></td> -->
                <td width="100" style="text-align:center">
                  <div class="cell">
                      <el-tag v-if="v.status == 1 && v.payState == 0" type="danger">未支付</el-tag>
                      <el-tag v-else-if="v.status == 1 && v.payState == 1 && v.logisticsState == 0" type="primary">备货中</el-tag>
                      <el-tag v-else-if="v.status == 1 && v.payState == 1 && v.logisticsState == 1" type="primary">复核完成</el-tag>
                      <el-tag v-else-if="v.status == 1 && v.payState == 1 && v.logisticsState == 2" type="success">已发货</el-tag>
                      <el-tag v-else-if="v.status == 3 && v.payState == 1 && v.logisticsState == 3 && (v.returnStatus == 3 || v.returnStatus == 2)" type="success">已完成</el-tag>
                      <el-tag v-else-if="v.status == 1 && v.payState == 2 && v.logisticsState == 0" type="primary">转账审核中</el-tag>
                      <el-tag v-else-if="v.status == 3 && v.payState == 5" type="success">已退款</el-tag>
                      <el-tag v-else-if="v.status == 4 && v.payState == 4" type="success">已退款</el-tag>
                      <el-tag v-else-if="v.status == 1 && v.payState == 2 && v.returnStatus == 1 && v.reviewer != null && v.refunder == null" type="warning">客服已审</el-tag>
                      <el-tag v-else-if="v.status == 3 && v.payState == 3 && v.returnStatus == 1 && v.reviewer != null" type="danger">客服拒绝</el-tag>
                      <el-tag v-else-if="v.status == 1 && v.payState == 2 && v.returnStatus == 1 && v.checker != null && v.refunder == null" type="warning">仓库已审</el-tag>
                      <el-tag v-else-if="v.status == 3 && v.payState == 3 && v.returnStatus == 1 && v.checker != null" type="danger">仓库拒绝</el-tag>
                      <el-tag v-else-if="v.status == 3 && v.payState == 4 && v.returnStatus == 1 && v.refunder != null" type="warning">财务已审</el-tag>
                      <el-tag v-else-if="v.status == 3 && v.payState == 3 && v.returnStatus == 1 && v.refunder != null" type="danger">财务拒绝</el-tag>
                      <el-tag v-else-if="v.status == 1 && v.payState == 2 && v.reviewer == null" type="warning">待审核</el-tag>
                      <el-tag v-else-if="v.status == 2 && v.payState == 1" type="warning">审核中</el-tag>
                      <el-tag v-else-if="v.status == 2 && v.payState == 2 && v.reviewer != null" type="warning">仓库审核中</el-tag>
                      <el-tag v-else-if="v.status == 2 && v.payState == 2 && v.checker != null" type="warning">财务审核中</el-tag>
                      <el-tag v-else-if="v.status == 3 && v.payState == 1 && v.returnStatus != 0 && v.reviewer == null && v.logisticsState < 2" type="warning">退款审核中</el-tag>
                      <el-tag v-else-if="v.status == 1 && v.payState == 1 && v.returnStatus != 0  && v.logisticsState >= 2" type="warning">退货审核中</el-tag>
                      <el-tag v-else>暂无</el-tag>
                  </div>
                </td>
                <td width="100" style="text-align:center">
                  <div class="cell">
                      <el-tag v-if="v.logisticsState == 0 && v.payState == 4 && v.status == 4" type="success">已退款</el-tag>
                      <el-tag v-else-if="v.logisticsState == 0 && v.payState !== 4 && v.status !== 4" type="primary">开始备货</el-tag>
                      <el-tag v-else-if="v.logisticsState == 1" type="success">复核完成</el-tag>
                      <el-tag v-else-if="v.logisticsState == 2" type="primary">已发货</el-tag>
                      <el-tag v-else-if="v.logisticsState == 3" type="success">已收货</el-tag>
                      <el-tag v-else-if="v.logisticsState == 9" type="primary">待确认</el-tag>
                      <el-tag v-else>暂无</el-tag>
                  </div>
                </td>
                <td style="text-align:center">
                  <div class="cell">
                    <p style="line-height:35px;">
                      <el-button size="mini" @click="handleViews(v.id)">查看</el-button>
                      <el-button size="mini" type="danger" v-if="v.payState == 0" @click="pay(v.id)">支付</el-button>
                      <!-- 未付款取消订单 -->
                      <el-button size="mini" type="warning" v-if="v.payState == 0 && v.status == 1" @click="close_order(v.id)">取消</el-button>
                      <!-- 转账取消订单 -->
                      <el-button size="mini" type="warning" v-if="v.payState == 2 && v.logisticsState == 9 && v.status != 2 && v.money > 0"  
                      @click="open_return_allorder(v.id)">取消订单</el-button>
                      <!-- 已付款取消订单 -->
                      <el-button size="mini" type="warning" v-if="v.payState == 1 && v.logisticsState < 2 && v.status != 2 && v.money > 0"  
                      @click="open_return_allorder(v.id)">取消订单</el-button>

                      <el-button size="mini" type="warning" v-if="v.payState == 1 && v.logisticsState == 3 && v.returnStatus == 0 || v.returnStatus == 2 || v.returnStatus == 3"  
                      @click="open_return_order(v)">退货退款</el-button>
                      <!-- <el-button size="mini" type="warning" v-if="v.payState == 1 && v.logisticsState == 3 && v.money > 0"  
                      @click="open_return_order(v)">退货退款</el-button> -->
                      <!-- 已付款已发货取消订单 -->
                      <!-- <el-button size="mini" type="primary" v-if="v.payState == 1 && v.logisticsState == 3 && v.reviewer != null && v.expressno != null && v.returnStatus !=2" @click="open_after_sale(v)">提交退货</el-button> -->
                      <el-button size="mini" type="primary" v-if="v.reviewer != null && v.returnFlow == null" @click="open_after_sale(v)">提交退货</el-button>

                      <!-- <el-button size="mini" type="primary" v-if="v.returnFlow !=null" @click="open_after_sale_speed(v)">查看售后</el-button> -->
                      <el-button size="mini" type="danger" v-if="v.logisticsState == 2" @click="change_order_status(v.id)">收货</el-button>
                      <el-button size="mini" type="danger" v-if="v.payLogId != null && v.payState == 2" @click="change_transfer(v)">转账凭证</el-button>
                      <el-button size="mini" type="primary" @click="order_buy_again(v.id)">再次购买</el-button>

                      <el-button
                      size="mini"
                      type="primary"
                      v-if="v.payState == 1 && v.logisticsState >= 2 && v.express == '京东快递'"
                      @click="showLogisticsDialog(v)">订单跟踪</el-button>

                      <el-button size="mini" type="warning" v-show="!v.invoice && (v.logisticsState == 3 || v.logisticsState == 4) && v.logisticsState != 9 && v.payState != 4 && v.payState != 5" @click="apply_invoice(v)">申请发票</el-button>
                      <el-button size="mini" type="primary" v-show="v.invoice" @click="views_invoice(v)">查看发票</el-button>
                    </p>
                  </div>
                </td>
                <td width="100" style="text-align:center">
                  <div class="cell">
                    <p><el-button v-show="v.payState == 1 && v.status != 2" @click="zcpj(v)" type="primary" size="mini">注册批件下载</el-button></p>
                    <p><el-button v-show="v.payState == 1 && v.status != 2" @click="yjbg(v)" type="primary" size="mini">药检报告下载</el-button></p>
                    <!-- <p><el-button v-show="v.payState == 1 && v.status != 2" @click="bjpzz(v)" type="primary" size="mini">保健品资质下载</el-button></p> -->
                  </div>
                </td>

              </tr>
            </tbody>
        </table>
      </div>

      <div class="home_empty_list" v-else>
        <i class="font iconfont">&#xe600;</i>暂无订单！
      </div>
      
      <div class="home_fy_block" v-show="order_list.length>0" style="margin-top:20px;" >
        <el-pagination v-if="elpagination" @current-change="current_change" background layout="prev, pager, next,jumper,total" :total="total_data" :page-size="page_size" :current-page="current_page"></el-pagination>
      </div>

      <!-- 转账凭证 -->
      <el-dialog title="转账凭证" :visible.sync="change_transferShow" width="30%">
          <div class="freight_info">
            <el-upload v-if="!payImg" style="width:200px; margin:0 auto;" class="avatar-uploader" :action="$api.uploadUserAvatar+'payImg'" :headers="upload_headers" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
              <img v-if="payImg" :src="payImg" class="avatar-upload">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <img style="width:200px; margin:0 auto;" v-else :src="payImg" class="avatar-upload">
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="change_transferShow = false" size="small">取消</el-button>
            <el-button type="primary" @click="paymentVoucher" size="small">确定</el-button>
          </span>
      </el-dialog>

      <!-- 已付款取消订单 -->
      <el-dialog title="提交售后" :visible.sync="returnOrderShow" :close-on-click-modal="false">
          <div class="freight_info">

            <div class="table-container" >
              <el-table :data="goodslist" @selection-change="handleDialogSelectionChange" border>
                <el-table-column type="selection" width="60" align="center"></el-table-column>
                <el-table-column label="ID" width="80" align="center">
                  <template slot-scope="scope">{{scope.row.id}}</template>
                </el-table-column>
                <el-table-column label="商品名称" align="center">
                  <template slot-scope="scope">{{scope.row.spuName}} <el-tag size="mini" effect="dark" v-if="scope.row.comboname">套餐({{scope.row.comboname}})</el-tag></template>
                </el-table-column>
                <el-table-column label="批号" width="120" align="center">
                  <template slot-scope="scope">{{scope.row.batchno}}</template>
                </el-table-column>
                <el-table-column label="数量" width="60" align="center">
                  <template slot-scope="scope">
                    {{scope.row.orderQty}}
                  </template>
                </el-table-column>
                <el-table-column label="实发" width="60" align="center">
                  <template slot-scope="scope">{{scope.row.qty}}</template>
                </el-table-column>
                <el-table-column label="退货数量" width="160" align="center">
                  <template slot-scope="scope">
                    <el-input-number v-model="scope.row.thnum" @change="handleChange" :min="thnum" :max="scope.row.qty" label="请选择退货数量"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="价格" width="120" align="center">
                  <template slot-scope="scope">￥{{scope.row.price}}</template>
                </el-table-column>
              </el-table>

              <br>

              <el-select v-model="OrdersReason" filterable placeholder="请选择取消原因">
                <el-option
                  v-for="item in selectOrdersReason"
                  :key="item.value"
                  :label="item.name"
                  :value="item.name">
                </el-option>
              </el-select>

            </div>

          </div>
          <span slot="footer" class="dialog-footer">
              <el-button @click="returnOrderShow = false" size="small">取消</el-button>
              <el-button @click="handleSelectDialogConfirm()" type="primary"  size="small">提交</el-button>
          </span>
      </el-dialog>

      <!-- 售后处理 -->
      <el-dialog title="售后处理" :visible.sync="afterSale">
          <div class="after_sale">
            <table class="detail-pro-table">
              <tbody>
                <tr>
                  <td colspan="2" class="singular_title">退货地址</td>
                </tr>
                <tr>
                  <td class="singular name-left">地址</td>
                  <td class="name-right">请联系客服获取退货地址</td>
                </tr>
                <!-- <tr>
                <td class="singular name-left">收货人</td>
                <td class="name-right parsetype"></td>
                </tr>
                <tr>
                <td class="singular name-left">联系电话</td>
                <td class="name-right"></td>
                </tr> -->
              </tbody>
            </table>

            <el-divider></el-divider>
            <div class="el-dialog__header">
              <span class="el-dialog__title">填写退货单</span>
            </div>
            <el-form :model="info"
              ref="info"
              :rules="rules"
              label-width="150px" size="small">
                <el-form-item label="订单号：">
                    <el-input  type="text" v-model="info.orderReturnApplyId" disabled></el-input>
                </el-form-item>
                <el-form-item label="选择物流：" prop="expressId" :rules="[{required:true,message:'物流公司不能为空',trigger: 'blur' }]">
                    <el-select v-model="info.expressId"  placeholder="请选择物流公司">
                    <el-option
                        v-for="item in selectCompany"
                        :key="item.value"
                        :label="item.company"
                        :value="item.id">
                    </el-option>
                    </el-select>
                    </el-form-item>

                <el-form-item label="快递单号：" prop="expressno" :rules="[{required:true,message:'物流单号不能为空',trigger: 'blur' }]">
                    <el-input type="text" placeholder="请输入快递单号" v-model="info.expressno"></el-input>
                </el-form-item>
            </el-form>
          </div>
          <span slot="footer" class="dialog-footer">
              <el-button @click="afterSale = false" size="small">取消</el-button>
              <!-- <el-button type="danger"  v-if="afterSaleInfo.refund_step==0" @click="refund()">申 请</el-button> -->
              <el-button type="danger" @click="submitForm('info')"  size="small">提交</el-button>
          </span>
      </el-dialog>

      <!-- 售后处理进度--暂时弃用 -->
      <el-dialog title="售后进度" :visible.sync="afterSalespeed">
          <div class="after_sale">
            <el-form :model="speed"
            ref="info"
            :rules="rules"
            label-width="150px" size="small">
                <el-form-item v-if="speed.reviewer == null" label="客服审核：">
                    <el-tag>待审核</el-tag>
                </el-form-item>
                  <el-form-item v-else-if="speed.reviewer !=null && speed.status==2 && speed.checker ==null && speed.refunder==null" label="客服审核：">
                    <el-tag type="danger">已拒绝</el-tag>
                </el-form-item>
                <el-form-item v-else label="客服审核：">
                    <el-tag type="success">已通过</el-tag>
                </el-form-item>

                <el-form-item v-if="speed.checker == null" label="仓库审核：">
                    <el-tag>待审核</el-tag>
                </el-form-item>
                  <el-form-item v-else-if="speed.checker !=null && speed.checker==2 && speed.refunder==null" label="仓库审核：">
                    <el-tag type="danger">已拒绝</el-tag>
                </el-form-item>
                <el-form-item v-else label="仓库审核：">
                    <el-tag type="success">已通过</el-tag>
                </el-form-item>

                <el-form-item v-if="speed.refunder == null" label="财务审核：">
                    <el-tag>待审核</el-tag>
                </el-form-item>
                  <el-form-item v-else-if="speed.refunder !=null && speed.refunder==2" label="财务审核：">
                    <el-tag type="danger">已拒绝</el-tag>
                </el-form-item>
                <el-form-item v-else label="财务审核：">
                    <el-tag type="success">已通过，已退款</el-tag>
                </el-form-item>
            </el-form>
          </div>
          <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="afterSalespeed = false" size="small">确定</el-button>
          </span>
      </el-dialog>

      <!-- 订单跟踪 -->
      <el-dialog title="订单跟踪"
                :visible.sync="logisticsDialogVisible"
                width="40%">
        <div class="table-container" style="height:400px;">
          <el-scrollbar style="height:100%; overflow-x: hidden">
            <el-timeline :reverse="reverse" style="padding:10px;">
              <el-timeline-item
                v-for="(item, index) in explist"
                :key="index"
                :timestamp="item.time">
                {{item.title}}
              </el-timeline-item>
            </el-timeline>
          </el-scrollbar>
        </div>

      </el-dialog>

      <!--申请发票-->
      <el-dialog title="申请发票"
                :visible.sync="applyInvoiceDialogVisible"
                width="40%">
        <div class="after_sale">
          <el-form :model="invoice"
            ref="invoice"
            :rules="rules"
            label-width="150px" size="small">
          
            <el-form-item label="订单号：" style="display:none;">
                <el-tag>{{invoice.id}}</el-tag>
            </el-form-item>
            <el-form-item label="发票类型：">
                <el-select v-model="invoice.invoiceType" filterable placeholder="请选择发票类型">
                  <el-option
                    v-for="item in selectInvoiceType"
                    :key="item.value"
                    :label="item.name"
                    :value="item.name">
                  </el-option>
                </el-select>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="applyInvoiceDialogVisible = false" size="small">取消</el-button>
            <!-- <el-button type="danger"  v-if="afterSaleInfo.refund_step==0" @click="refund()">申 请</el-button> -->
            <el-button type="danger" @click="submitInvoiceForm('invoice')"  size="small">提交</el-button>
        </span>

      </el-dialog>

      <!--查看发票-->
      <el-dialog title="查看发票"
                :visible.sync="viewsInvoiceDialogVisible"
                width="40%">
        <div class="table-container">

          <el-table
            :data="invoiceList"
            stripe
            style="width: 100%">
                <el-table-column label="发票类型" width="190" align="center" sortable prop="createtime">
                  <template slot-scope="scope">
                    <el-tag size="small">{{scope.row.invoice_type}}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="发票号" width="190" align="center" sortable prop="createtime">
                  <template slot-scope="scope">
                    <el-tag size="small">{{scope.row.fapiaoh}}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="查看" align="center">
                  <template slot-scope="scope">
                    <el-tag size="small" type="primary" v-if="scope.row.url != ''" @click="handleViewInvoice(scope.$index, scope.row)">查看发票</el-tag>
                      <el-tag size="small" type="info" v-else>查看发票</el-tag>
                  </template>
                </el-table-column>
          </el-table>

        </div>

      </el-dialog>

    </div>
</template>

<script>
import {formatDate} from '@/utils/date';
export default {
    components: {},
    props: {},
    data() {
      return {
          activeOrder: 'first',
          order_list:[],
          cancelOrder_list:[],
          list:[],
          order_num:{},
          total_data:0, // 总条数
          page_size:10,
          current_page:1,
          orderTime:[],
          order_type:0,
          deliveryShow:false,
          orderShow:false,
          reverse:null,
          returnOrderShow:false,
          change_transferShow:false,
          logisticsDialogVisible:false,
          applyInvoiceDialogVisible:false, //申请发票
          viewsInvoiceDialogVisible:false, //查看发票
          selectInvoiceType:{}, //发票类型
          invoiceList:[], //发票列表
          expOrderId:null,
          explist:[],
          delivery_list:undefined,
          afterSale:false,
          afterSalespeed:false,
          info:{
              orderReturnApplyId:'',
              express:'',
              expressId:'',
              expressno:'',
              remark:'',
          },
          speed:{},
          selectCompany:[],
          goodslist:[],
          invoice:[],
          invoiceType:[],
          OrdersReason:[],
          count_list:[],
          elpagination:true,
          num:0,
          thnum:0,
          rules:[],
          payLogId:null,
          payImg:null,
          upload_headers:{},
          canceltotal:'',
          selectOrdersReason:{},
          keyword:null, //根据订单号或商品名称搜索
          startTime:null,
          endTime:null,
          listLoading:false,
      };
    },
    watch: {},
    computed: {},
    filters:{
      formatCreateTime(time) {
        let date = new Date(time);
        if(time===undefined||time===null||time===''){
          return '暂无';
        }else{
          return formatDate(date, 'yyyy-MM-dd hh:mm:ss');
        }
      },
      //订单状态
      formatorderState(value) {
        if(value===undefined||value===null||value===''){
          return '暂无';
        }else if (value === 0) {
          return '未确认';
        } else if (value === 1) {
          return '已确认';
        } else if (value === 2) {
          return '已取消';
        } else if (value === 3) {
          return '已确认取消';
        }
      },
      //支付方式
      formatpanyment(value) {
        if(value===undefined||value===null||value===''){
          return '暂无';
        }else if (value === 0) {
          return '未支付';
        } else if (value === 1) {
          return '扫码支付';
        } else if (value === 2) {
          return '中国银联';
        } else if (value === 3) {
          return '余额支付';
        } else if (value === 4) {
          return '线下转账';
        }
      },
      //支付状态
      formatpayState(value) {
        if(value===undefined||value===null||value===''){
          return '暂无';
        }else if (value === 0) {
          return '未支付';
        } else if (value === 1) {
          return '已支付';
        } else if (value === 2) {
          return '待审核';
        } else if (value === 3) {
          return '已审核';
        } else if (value === 4) {
          return '已退款';
        } else if (value === 5) {
          return '已取消';
        }
      },
      formatTime(time) {
        let date = new Date(time);
        if(time===undefined||time===null||time===''){
          return '暂无';
        }else{
          return formatDate(date, 'yyyy-MM-dd');
        }
      },
      //订单状态
      //   formatreviewer(value) {
      //     if (value === null) {
      //       return '等待客服审核';
      //     } else if (value != null) {
      //       return '';
      //     }
      //   },
      formatrefunder(value) {
        if (value === null) {
          return '待审核';
        } else if (value != null) {
          return '已确认取消';
        }
      },
    },
    methods: {
      //附件路径
      filepath:function(){ 
            this.$get(this.$api.filepath,{platId:this.$platId}).then(res=>{
              this.filePath = res.data[0].config;
          });
      },

      //打开转账凭证
      change_transfer(v) {
        this.change_transferShow = true;
        this.payImg = v.payImg;
        this.payLogId = v.payLogId;
      },

      //保存转账凭证
      paymentVoucher:function(){
          this.$post(this.$api.paymentVoucher,{payLogId:this.payLogId,payImg:this.payImg}).then(res=>{
              if(res.code==200){
                  this.$message.success(res.message);
                  this.change_transferShow = false;
                  this.get_user_order();
              }else{
                  this.$message.error(res.message);
              }

          });
      },

      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isPNG = file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 5;
        var isIMG = true;
        if (!isJPG) {
            if (!isPNG) {
            this.$message.error('上传图片只能是 JPG, PNG 格式!');
            isIMG = false;
            }
        }
        if (!isLt2M) {
            this.$message.error('上传图片大小不能超过 5MB!');
        }
        return isIMG && isLt2M;
      },

      handleAvatarSuccess(res) {
        this.payImg = this.filePath + res.data;
        this.$forceUpdate();
      },

      handleChange() {
        // console.log(value);
      },

      //打开退货订单弹窗
      open_return_order:function(v){
          this.return_orderid = v.id;
          this.returnOrderShow = true;
          this.$get(this.$api.queryOrderDetailByOrderId + v.id).then(response=>{
          this.goodslist = response.data.orderDetailParamList;
          for (let i = 0; i < this.goodslist.length; i++) {
            if(this.goodslist[i].qty == 0){
                this.goodslist[i].thnum = 0;
            }
          }
          this.list.length = response.data.orderDetailParamList.length;
          this.get_user_order();
          });
      },

      //选择退货原因
      getreturnType() {
          this.$get(this.$api.getBasedictType + "cancel_reason").then(response=>{
            this.selectOrdersReason = response.data;
        });
      },


      //选择退货商品ID
      handleDialogSelectionChange(val){
        this.multipleSelection = val;
        // for (let i = 0; i < this.multipleSelection.length; i++) {
        //   if(this.multipleSelection[i].qty == 0){
        //     this.$refs.goodslistable.toggleRowSelection(val,true);
        //   }
        // }
      },

      //提交退货订单
      handleSelectDialogConfirm(){
        if(this.multipleSelection < 1) {
          return this.$message.error('请选择一条记录');
        }else if(this.multipleSelection == undefined){
          return this.$message.error('请选择一条记录');
        }
        let orderDetailId = "";
        let orderDetailth = "";
        for (let i = 0; i < this.multipleSelection.length; i++) {
          orderDetailId+= ","+this.multipleSelection[i].id;
          orderDetailth+= ","+this.multipleSelection[i].thnum;
          if(this.multipleSelection[i].thnum == undefined){
            return this.$message.error('请填写' + this.multipleSelection[i].spuName + '退货数量');
          }else if(this.multipleSelection[i].thnum < '0'){
            return this.$message.error(this.multipleSelection[i].spuName + '退货数量不能小于0');
          }
        }
        this.$confirm('是否要进行该操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            this.$put(this.$api.cancelOrdersByOrderIdToUser,{orderId:this.return_orderid,"reason":this.OrdersReason,orderDetailId,orderDetailth}).then(response=>{
              if(response.code == 200){
                  this.$message({
                    type: 'success',
                    message: '操作成功!'
                  });
                  this.get_order_count();
                  this.get_user_order();
                  this.cancelOrderDisplay();
                  this.returnOrderShow=false;
                  this.multipleSelection=[];
              }else{
                  this.get_order_count();
                  this.get_user_order();
                  this.cancelOrderDisplay();
                  this.$message.error(response.message);
              }
            });


        //   if(this.multipleSelection.length == this.list.length){
        //   this.$put(this.$api.cancelOrdersByOrderIdToUser,{orderId:this.return_orderid,"reason":this.OrdersReason,orderDetailId:'null'}).then(response=>{
        // //   cancelOrdersByOrderDetailId({orderId:this.$route.query.id,"reason":this.OrdersReason,orderDetailId:'null'}).then(response=>{
        //     if(response.code == 200){
        //         this.$message({
        //           type: 'success',
        //           message: '操作成功!'
        //         });
        //         this.get_user_order();
        //         this.returnOrderShow=false;
        //         this.multipleSelection=[];
        //     }else{
        //         return this.$message.error(response.message);
        //     }
        //   });
        //   }else{
        //    //console.log(orderDetailth);
        //    this.$put(this.$api.cancelOrdersByOrderIdToUser,{orderId:this.return_orderid,"reason":this.OrdersReason,orderDetailId,orderDetailth}).then(response=>{
        //     if(response.code == 200){
        //         this.$message({
        //           type: 'success',
        //           message: '操作成功!'
        //         });
        //         this.get_user_order();
        //         this.returnOrderShow=false;
        //         this.multipleSelection=[];
        //     }else{
        //         return this.$message.error(response.message);
        //     }
        //   });
        //   }

        });
      },

      formatTime: function (date, fmt) {
          var time = new Date(date);
          if (/(y+)/.test(fmt)) {
              fmt = fmt.replace(RegExp.$1, (time.getFullYear() + '').substr(4 - RegExp.$1.length));
          }
          var o = {
              'M+': time.getMonth() + 1,
              'd+': time.getDate(),
              'h+': time.getHours(),
              'm+': time.getMinutes(),
              's+': time.getSeconds()
          };
          for (var k in o) {
              if (new RegExp('('+k+')').test(fmt)) {
                  var str = o[k] + '';
                  fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : ('00' + str).substr(str.length));
              }
          }
          return fmt;
      },


      //订单列表
      get_user_order:function(){
        this.listLoading = true;
        if(this.orderTime == null || this.orderTime.length == 0){
          this.orderTime = [];
          this.startTime = '';
          this.endTime = '';
        }else{
          this.startTime = this.formatTime(this.orderTime[0],'yyyy-MM-dd hh:mm:ss');
          this.endTime = this.formatTime(this.orderTime[1],'yyyy-MM-dd hh:mm:ss');
        }
        this.$get(this.$api.homeGetUserOrder,{
          pageSize:this.page_size,
          pageNum:this.current_page,
          orderType:this.order_type,
          keyword:this.keyword,
          startTime:this.startTime,
          endTime:this.endTime,
          platId:this.$platId
        }).then(res=>{
          if(res.code == 401){
              this.$message.error(res.message);
              localStorage.removeItem('userInfo');
              localStorage.removeItem('token');
              this.$router.push('/user/login/');
          }
          this.listLoading = false;
          this.order_list = res.data.list;
          this.page_size = res.data.pageSize;
          this.current_page = res.data.pageNum;
          this.total_data = res.data.total;
          this.get_order_count();
        }).catch(err=>{
          this.listLoading = false;
        });
      },

      //根据时间参数查询订单
      getquerySconfigInfo:function(){
        this.$get(this.$api.querySconfigInfo + 'order_query_day',{platId:this.$platId}).then(res=>{
          var todayYear = (new Date()).getFullYear()
          var todayMonth = (new Date()).getMonth()
          var todayDay = (new Date()).getDate()
          var end = new Date(todayYear, todayMonth, todayDay, '23', '59', '59');
          var start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * res.data);
          this.orderTime = [start, end];
          // console.log(this.orderTime);
          this.get_user_order();
        })
      },


      //重置搜索
      handleResetSearch() {
        this.orderTime = [];
        this.startTime = '';
        this.endTime = '';
        this.keyword = null
        this.current_page = '1';
        this.get_order_count();
        this.get_user_order();
        this.cancelOrderDisplay();
        // this.$get(this.$api.homeGetUserOrder,{pageSize:this.page_size,pageNum:this.current_page,orderType:this.order_type,platId:this.$platId}).then(res=>{
        //     this.order_list = res.data.list;
        //     this.page_size = res.data.pageSize;
        //     this.current_page = res.data.pageNum;
        //     this.total_data = res.data.total;
        // });
      },

      //取消订单列表
      cancelOrderDisplay:function(){
        this.listLoading = true;
        if(this.orderTime == null || this.orderTime.length == 0){
          this.orderTime = [];
          this.startTime = '';
          this.endTime = '';
        }else{
          this.startTime = this.formatTime(this.orderTime[0],'yyyy-MM-dd hh:mm:ss');
          this.endTime = this.formatTime(this.orderTime[1],'yyyy-MM-dd hh:mm:ss');
        }
        this.$get(this.$api.cancelOrderDisplay,{pageSize:this.page_size,pageNum:this.current_page,orderType:5,keyword:this.keyword,startTime:this.startTime,endTime:this.endTime,platId:this.$platId}).then(res=>{
          this.listLoading = false;
          if(res.data){
            if(res.data.list){
              this.order_list = res.data.list;
            }else{
              this.order_list = []
            }
            // this.page_size = res.data.pageSize;
            // this.current_page = res.data.pageNum;
            this.total_data = res.data.total;
            this.canceltotal = res.data.total;
          }
        }).catch(err=>{
            this.listLoading = false;
        });
      },


      //订单统计
      get_order_count:function(){
          this.$get(this.$api.orderCount,{
            platId:this.$platId,
            starttime : this.orderTime[0],
            endtime : this.orderTime[1],
          }).then(res=>{
              this.count_list = res.data;
          });
      },

      // 分页改变
      current_change:function(e){
          this.current_page = e;
          this.get_user_order();
          this.$scrollTo();
      },

      pay:function(id){
          // let order_info = this.order_list[index];
          // // console.log(this.order_list[index]);
          // let order_no = order_info.order_no;
          // let strArr = [];
          // let str = '';
          // order_info.order_goods.forEach(res => {
          //     str = res.goods_id+'|'+order_info.store_id+'|'+res.goods_num;
          //     if(!this.$isEmpty(res['spec_id']) && res['spec_id']>0){
          //         str += '|'+res['spec_id'];
          //     }
          //     strArr.push(str);
          // });
          // let str_info = strArr.join(',');
          return this.$router.push('/order/chose_pay/'+id)
      },

        // 未付款取消订单
      close_order:function(id){
        this.$confirm('是否要进行该操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$put(this.$api.cancelOrdersByOrderId + id).then(res=>{
              if(res.code == 200){
                this.get_order_count();
                this.get_user_order();
                return this.$message.success(res.message);
              }else{
                return this.$message.error(res.message);
              }
          });
        })
      },

      // 付款未发货全部取消
      open_return_allorder:function(id){
        this.$confirm('是否要进行该操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$put(this.$api.cancelBeforeReview,{orderId:id}).then(response=>{
            if(response.code == 200){
                this.$message({
                  type: 'success',
                  message: '操作成功!'
                });
                this.get_order_count();
                this.get_user_order();
            }else{
                return this.$message.error(response.message);
            }
          });
        })
      },


         //退货退款申请
      return_order:function(id){
        this.$confirm('是否要进行该操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$put(this.$api.cancelOrdersByOrderIdToUser + id).then(res=>{
              if(res.code == 200){
                this.get_user_order();
                return this.$message.success('退款申请成功');
              }else{
                return this.$message.error(res.message);
              }
          });
        })
      },

         //退货申请
      refund_order:function(id){
        this.$confirm('是否要进行该操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$put(this.$api.cancelOrdersByOrderIdToUser + id).then(res=>{
              if(res.code == 200){
                this.get_user_order();
                return this.$message.success('退货申请成功');
              }else{
                return this.$message.error(res.message);
              }
          });
        })
      },


      // 确认收货
      change_order_status:function(id){
          this.$get(this.$api.confirmReceipt+ id).then(res=>{
              this.get_order_count();
              this.get_user_order();
              this.$message.success(res.message);
          });
      },

      //选择物流公司
      getSelectCompany() {
          this.$get(this.$api.listExpress,{pageSize: 1000, pageNum: 1}).then(response=>{
          //fetchAllwldwcope(this.listQuery).then(response => {
          this.selectCompany = response.data.list;
          });
      },

      //物流跟踪
      showLogisticsDialog(v){
      this.expOrderId = v.id;
      this.$get(this.$api.exterfaceInvoke + this.expOrderId).then(res => {
        if(res.code == 200){
          if(res.data != null){
            this.logisticsDialogVisible=true;
            this.explist = res.data;
          }else{
            this.$message.error('暂无物流信息');
            this.logisticsDialogVisible = false;
          }
        }
        });
      },


      // 打开售后处理
      open_after_sale:function(v){
          this.afterSale = true;
          this.info.orderReturnApplyId = v.orderIdReturn;
          // this.afterParams = v;
      },
      //售后进度
      open_after_sale_speed:function(v){
          this.afterSalespeed = true;
          this.speed = v;
      },

      submitForm:function(e){
        if(!this.info.expressId){
          this.$message.error('请选择物流公司!');
          return
        }
        if(!this.info.expressno){
          this.$message.error('请填写物流单号!');
          return
        }
          let _this = this;
          // 验证表单
          this.$refs[e].validate(function(res){
              if(res){
                  //  判断是Add 或者 Edit
                  let url = _this.$api.warehouseExpressUpdate;
                  // Http 请求
                  _this.$post(url,_this.info).then(function(res){
                      if(res.code == 200){
                          _this.$message.success(res.message);
                          _this.afterSale = false;
                          _this.get_user_order();
                      }else{
                          _this.$message.error(res.message);
                      }
                  });

              }
          });
      },


      //订单详情
      handleViews:function(id){
          // this.$router.push({path: '/user/order_info', query: {id: id}})
          let routeData = this.$router.resolve({ path: '/user/order_info', query: {id: id}});
          window.open(routeData.href, '_blank');
      },

      //取消订单详情
      handleCancelViews:function(id){
          let routeData = this.$router.resolve({ path: '/user/order_info', query: {id: id}});
          window.open(routeData.href, '_blank');
      },


      // 再次购买
      order_buy_again:function(id){
        this.listLoading = true
          this.$get(this.$api.joinAgain + id,{platId:this.$platId}).then(res=>{
            this.listLoading = false;
            this.$message.success(res.message);
            this.$router.push({path: '/cart/index'});
          }).catch(err=>{
              this.listLoading = false;
          });
      },


      // 注册批件下载
      zcpj:function(v){
        this.$confirm('文件可能过多，需要一些时间，请您耐心等待?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          //window.location.href = 'this.$api/kxorders/userOrder/zcyj?id='+v.id+'&type=zcpj';
          let a = document.createElement('a')
          a.href = this.$api.baseUrl+'kxorders/userOrder/zcyj?id='+v.id+'&type=zcpj',
          a.click();
        })
      },

      // 药检下载
      yjbg:function(v){
        this.$confirm('文件可能过多，需要一些时间，请您耐心等待?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          //window.location.href = 'this.$api/kxorders/userOrder/zcyj?id='+v.id+'&type=zcpj';
          let a = document.createElement('a')
          a.href = this.$api.baseUrl+'kxorders/userOrder/zcyj?id='+v.id+'&type=yjbg',
          a.click();
        })
      },

        //保健品资质下载
      bjpzz:function(v){
        this.$confirm('文件可能过多，需要一些时间，请您耐心等待?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          //window.location.href = 'this.$api/kxorders/userOrder/zcyj?id='+v.id+'&type=zcpj';
          let a = document.createElement('a')
          a.href = this.$api.baseUrl+'kxorders/userOrder/downloadSpuCeriftcate/'+ v.id,
          a.click();
        })
      },

      //申请发票
      apply_invoice:function(info){
        this.applyInvoiceDialogVisible = true;
        this.invoice.id = info.id;
        this.$get(this.$api.getBasedictType + "invoice_type").then(res=>{
          if(res.code == 200){
            this.selectInvoiceType = res.data;
          }
        });
      },
        
      submitInvoiceForm:function(){
        if(!this.invoice.invoiceType){
          this.$message.success('请选择发票类型!');
        }else{
          this.$post(this.$api.invoiceRequest,{orderId:this.invoice.id,invoiceType:this.invoice.invoiceType}).then(res=>{
            if(res.code == 200){
              this.applyInvoiceDialogVisible = false;
              this.$message.success(res.message);
            }else{
              this.$message.error(res.message);
            }
          });
        }
      },

      //查看发票
      views_invoice:function(info){
            this.viewsInvoiceDialogVisible = true;
          this.$get(this.$api.invoiceDownload,{orderId:info.id,platId:this.$platId}).then(res=>{
            if(res.code == 200){
              this.invoiceList = res.data;
            }
          });
      },

      //查看发票
      handleViewInvoice(index, row){
        window.open(row.url,'_blank')
        // window.location.href = row.url;
      },
    },
    created() {
      if(!this.$isEmpty(this.$route.params.order_type)){
          this.order_type = this.$route.params.order_type;
      }
      this.filepath();
      // this.get_order_count();
      this.getquerySconfigInfo();
      // this.get_user_order();
      // this.cancelOrderDisplay();
      this.getSelectCompany(); 
      this.getreturnType();
      // this.upload_headers.Authorization = 'Bearer '+localStorage.getItem('token'); // 要保证取到
    },
    mounted(){}
};
</script>
<style lang="scss" scoped>
.no_freight{
    line-height: 60px;
    text-align: center;
    font-size: 14px;
    color:#999;
}
.handle_btn{
    text-align: right;
    margin: 20px 0;
}
.user_index_order_list{
    margin-bottom: 50px;
}
.order_time{
    margin-left: 20px;
    color:#666;
    float: right;
    font-size: 12px;
}
.user_index_store_list{
    ul{
        border:1px solid #efefef;
        
    }
    ul li{
        border-bottom: 1px solid #efefef;
        padding:20px 15px;
    }
    ul li:last-child{
        border-bottom: none;
    }
}
.user_order_goods_thumb{
    float: left;
    margin-right: 15px;
    display: block;
    width: 40px;
    
}

.user_order_goods_title{
    font-size: 12px;
    color:#666;
    width: 280px;
    float: left;
}
.user_order_goods_num{
    font-size: 12px;
    color:#666;
    float: left;
    display: block;
    line-height: 40px;
    width: 200px;
    text-align: center;
}
.user_order_goods_price{
    font-size: 12px;
    line-height: 40px;
    color:#409EFF;
    width: 90px;
    float: left;
}
.order_search{
    float: right;
    margin-left: 20px;
    right: 10px;
}
.user_index_store_title{
    background: #f6f6f6;
    line-height: 40px;
    color:#666;
    padding:0 15px;
    margin:20px 0;
    a:hover{
        color:#409EFF;
    }
}
.order_type{
    float: right;
    font-size: 14px;
    margin-top: 2px;
    ul{
        margin-right: 0px;
        
    }
    ul li {
        color:#999;
        float: left;
        margin-right: 20px;
        cursor: pointer;
    }
    ul li.red{
        color:#409EFF;
    }
    ul li:hover{
        color: #409EFF;
    }
}
.detail-pro-table{margin-top: 15px; width: 100%;}
.detail-pro-table td{font-size: 14px; color: #666666; text-align: left; border: 1px solid #E6E6E6; text-indent: 10px; height: 30px;line-height: 30px; padding: 5px 0;}
.detail-pro-table td.name-left{width:100px;}
.detail-pro-table td.singular{background: #fafafa;}
.detail-pro-table td.singular_title{background: #fafafa; font-size:18px; font-weight: normal;}
.el-button{
  margin-left: 5px;
  margin-right: 5px;
}

.cell p{
  margin: 5px 0;
}

</style>

<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>